import type { CSSProperties } from 'react'

/** Stagger helper for [data-reveal] elements — feeds the --d transition delay. */
export const delay = (seconds: number): CSSProperties =>
    ({ '--d': `${seconds}s` }) as CSSProperties
